import { AlertingHistoryPage as SharedAlertingHistoryPage } from '@jarvis/platform-ui';

export function AlertingHistoryPage() {
  return <SharedAlertingHistoryPage stateStorageKey="webopsui:alerting-history-grid" />;
}
